import { Alert, AlertProps } from "antd";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";
import { TranscriptHubContext } from "../providers/TranscriptHubProvider";

export default function AlertList(): ReactElement {
  const { isChatOnlyMode, isTranslationEnabled } = useContext(TranscriptHubContext);
  const { t } = useTranslation();

  const alerts: AlertProps[] = [];

  if (isChatOnlyMode) {
    alerts.push({
      type: "info",
      closable: true,
      message: (
        <span>
          <strong>{t("chatOnlyMode.title")}</strong>
          {" "}
          {t("chatOnlyMode.description")}
        </span>
      ),
    });
  }

  if (!isTranslationEnabled) {
    alerts.push({
      type: "info",
      closable: true,
      message: (
        <span>
          <strong>{t("noTranslationMode.title")}</strong>
          {" "}
          {t("noTranslationMode.description")}
        </span>
      ),
    });
  }

  return (
    <div>
      {alerts.map((props, index) => <Alert key={index} banner showIcon {...props} />)}
    </div>
  );
}
